import React from 'react';
import { Section } from './Section';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsItFor() {
  const forYou = ['Ya vendes productos físicos', 'Tienes operación activa', 'Quieres lanzar tu primera tienda online profesional', 'Quieres evitar errores costosos desde el inicio', 'Buscas estructura, control y acompañamiento', 'Estás evaluando invertir en una solución profesional'];
  const notForYou = ['Todavía no tienes productos', 'No tienes ventas ni operación real', 'Buscas la opción más barata', 'Solo quieres una web simple', 'Esperas que una tienda venda sola sin tráfico ni gestión', 'No estás dispuesto a ordenar información, productos o procesos'];
  return <Section className="bg-white" data-id="element-376">
      <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-377">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy-900 mb-4" data-id="element-378">
          BitzenEscala™ no es para todos
        </h2>
        <p className="text-lg text-slate-600" data-id="element-379">
          Trabajamos con pymes retail que tienen operación real y están listas
          para construir su canal online con seriedad.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-380">
        {/* Es para ti */}
        <div className="bg-green-50 rounded-3xl p-8 md:p-10 border border-green-100 shadow-sm" data-id="element-381">
          <h3 className="text-2xl font-heading font-bold text-green-900 mb-6" data-id="element-382">
            Es para ti si...
          </h3>
          <div className="space-y-4" data-id="element-383">
            {forYou.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-384">
                <CheckCircle2 className="w-6 h-6 text-green-600 shrink-0 mt-0.5" data-id="element-385" />
                <span className="text-green-900 font-medium" data-id="element-386">{item}</span>
              </div>)}
          </div>
        </div>

        {/* No es para ti */}
        <div className="bg-slate-50 rounded-3xl p-8 md:p-10 border border-slate-200 shadow-sm" data-id="element-387">
          <h3 className="text-2xl font-heading font-bold text-slate-800 mb-6" data-id="element-388">
            No es para ti si...
          </h3>
          <div className="space-y-4" data-id="element-389">
            {notForYou.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-390">
                <XCircle className="w-6 h-6 text-slate-400 shrink-0 mt-0.5" data-id="element-391" />
                <span className="text-slate-600 font-medium" data-id="element-392">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
}